import { apiClient } from "../../api/client";

export interface DashboardResponse {
  totalUsers: number;
  totalFiles: number;
  totalFilesAssigned: number;
}

export async function fetchDashboard(): Promise<DashboardResponse> {
  try {
    const response = await apiClient.get<DashboardResponse>(
      `/Dashboard/dashboard`
    );

    return response.data as DashboardResponse;
  } catch (error) {
    

    // Simulate propagation of the error for the list view; comment instead of deleting
    // return fallbackTemplatesResponse;
    throw error;
  }
}
